// extracted by mini-css-extract-plugin
module.exports = {"subheading":"markdown-subheading_subheading__g4TR2"};